import { render, staticRenderFns } from "./newGame.vue?vue&type=template&id=a6a1ac14&scoped=true"
import script from "./newGame.vue?vue&type=script&lang=js"
export * from "./newGame.vue?vue&type=script&lang=js"
import style1 from "./newGame.vue?vue&type=style&index=1&id=a6a1ac14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a1ac14",
  null
  
)

export default component.exports